import React from 'react';
import './CaseStudies.css';

const caseStudies = [
  {
    industry: 'Aviation Services',
    tag: 'New Business Vertical',
    challenge: 'Development of a new business vertical — Airline Inflight and Onboard Service Operations — with no prior market presence or operational structure.',
    solutionLabel: 'StratX Intervention',
    solution: [
      'Aviation market & competitor research',
      'Complete business model creation',
      'Operational structure + revenue planning',
      'Go-to-market strategy design',
      'Full implementation roadmap',
    ],
    resultsLabel: 'Impact',
    results: [
      'New airline vertical successfully launched',
      'Clear 5-year scalability plan established',
      'Strong market entry & operational readiness',
    ],
    metrics: null,
  },
  {
    industry: 'Hospitality Industry',
    tag: 'Revenue Transformation',
    challenge: 'No clear strategic roadmap. Inadequate operational and market insights leading to stagnant revenue and weak market visibility across target geographies.',
    solutionLabel: 'StratX Solution',
    solution: [
      'Business diagnostics & gap analysis',
      '12-month strategic roadmap development',
      'Pricing + marketing optimization',
      'Market positioning strengthened',
    ],
    resultsLabel: 'Results',
    results: [
      '+28% revenue growth in Year 1',
      '+46% revenue growth in Year 2',
      'Stronger visibility across India, ME & Africa',
    ],
    metrics: [
      { value: '+28%', label: 'Year 1 Revenue' },
      { value: '+46%', label: 'Year 2 Revenue' },
    ],
  },
];

const CaseStudies = () => (
  <section id="cases" className="sec">
    <div className="w">
      <div className="rv">
        <div className="eye">Proven Impact</div>
        <h2 className="sh">Case <span>Studies</span></h2>
        <p className="sl">Trusted by leading organizations. Explore how StratX drives transformative business growth.</p>
      </div>
      <div className="csg">
        {caseStudies.map((study, index) => (
          <div className={`cscd rv d${index + 1}`} key={study.industry}>
            <div className="csh">
              <span className="csi">{study.industry}</span>
              <span className="cstg">{study.tag}</span>
            </div>
            <div className="csb">
              <div className="css2">
                <div className="cssl">Challenge</div>
                <div className="csst">{study.challenge}</div>
              </div>
              <div className="css2">
                <div className="cssl">{study.solutionLabel}</div>
                {study.solution.map((item) => (
                  <div className="csli" key={item}>
                    <div className="csb2" />
                    {item}
                  </div>
                ))}
              </div>
              <div className="css2">
                <div className="cssl">{study.resultsLabel}</div>
                {study.results.map((item) => (
                  <div className="csli rr" key={item}>
                    <div className="csb2" />
                    {item}
                  </div>
                ))}
              </div>
              {study.metrics && (
                <div className="csm">
                  {study.metrics.map((m) => (
                    <div className="csmm" key={m.label}>
                      <div className="csmv">{m.value}</div>
                      <div className="csml">{m.label}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CaseStudies;
